import {useState} from "react";
import {Input, Button, Typography, App as AntdApp} from "antd";
import styles from "./ResultsTop.module.css";

export const ResultsTop = ({currentTop, onTopChange, loading}) => {
	const [showEdit, setShowEdit] = useState(false);
	const [inputTop, setInputTop] = useState(currentTop);

	const {message} = AntdApp.useApp();

    function handleInput(event) {
		const value = event.target.value;
		const input = value !== "" ? parseInt(value, 10) : value;

		if (value === "" || !isNaN(input)) {
			setInputTop(input);
		}
	}

	function handleSubmit() {
		if (loading) {
			message.error("Previous query is still executing. Please wait till the results show up", 5);
			return;
		}

		const isInvalid = inputTop === "" || inputTop < 1;
		const finalTop = isInvalid ? currentTop : inputTop;

		setInputTop(finalTop);
		setShowEdit(false);
		onTopChange(finalTop);
	}

    function handleCancel() {
        setInputTop(currentTop);
        setShowEdit(false);
    }

    function handleKeyDown(event) {
        if (event.key === "Escape") {
            handleCancel();
        }
    }

	return (
		<div className={styles.wrapper}>
			Number of shown results:{" "}
			{showEdit ? (
				<>
					<Input
						className={styles.input}
						maxLength={3}
						value={inputTop}
						onChange={handleInput}
						autoFocus
						onPressEnter={handleSubmit}
                        onKeyDown={handleKeyDown}
				/>
					<Button onMouseDown={handleSubmit}>Submit</Button>
				</>
			) : (
				<Typography.Link onClick={() => setShowEdit(true)}>{currentTop}</Typography.Link>
			)}
		</div>
	);
};
